import type { ProgressSaveData } from '../../../../app/state/AppStateController';
import type { LevelTaskType } from '../../../tasks/types';
import type { BoardModel } from '../board/BoardModel';
import type { TrayModel } from '../tray/TrayModel';
import type { LevelTasksTracker } from '../../../tasks/LevelTasksTracker';
import { BlockerType } from '../../types';

export class BoosterUndoModel {
  public readonly stateHistory: ProgressSaveData[] = [];

  constructor(
    private readonly boardModel: BoardModel,
    private readonly trayModel: TrayModel,
    private readonly taskTracker: LevelTasksTracker,
  ) {}

  public addProgressData(progressData: ProgressSaveData): void {
    this.stateHistory.push(progressData);
  }

  public clearHistory(): void {
    this.stateHistory.length = 0;
  }

  public canExecute(): boolean {
    return this.stateHistory.length > 0 && this.boardModel.isIdle() && this.taskTracker.getCombinedProgress() < 1;
  }

  public execute(): void {
    const stateToGoBack = this.stateHistory.pop();
    if (!stateToGoBack?.levelData?.board) return;

    // Filter out coin/ad blockers that were previously unlocked
    const nonRewindableBlockerTypes = [BlockerType.Coin, BlockerType.Ad];

    const currentBlockers = this.boardModel
      .getStacks()
      .filter((stack) => stack.blocker && nonRewindableBlockerTypes.includes(stack.blocker.getType()));

    const filteredBoardState = {
      ...stateToGoBack.levelData.board,
      blockers: stateToGoBack.levelData.board.blockers?.filter((blocker) => {
        if (!nonRewindableBlockerTypes.includes(blocker.type)) return true;
        return currentBlockers.some(
          (current) =>
            current.x === blocker.x && current.y === blocker.y && current.blocker?.getType() === blocker.type,
        );
      }),
    };

    this.boardModel.importState(filteredBoardState);

    Object.entries(stateToGoBack.levelTaskTallies).forEach(([key, value]) => {
      this.taskTracker.setTaskItemValue(key as LevelTaskType, value);
    });
    
    this.trayModel.setState(stateToGoBack?.levelData?.tray);
  }
}
